<div class="equis" (click)="onCancel()">X</div>
<h1 class="mall-title">Selecciona un centro comercial</h1>
<div class="mall-line"></div>
<div class="mall-desc">
  Elige el centro comercial en el que deseas construir tu almacén
</div>
<div class="buscador">
  <div class="row">
    <div class="input col-md-7">
      <input class="search-input" placeholder="Buscar" />
    </div>
    <div class="select col-md-4">
      <select class="select-personalizado">
        <option style="font-family: Montserrat;" value="0">
          Filtro
        </option>
        <option style="font-family: Montserrat;" value="1">
          Mayor vistas
        </option>
        <option style="font-family: Montserrat;" value="2">
          Mayor audiencia
        </option>
      </select>
    </div>
  </div>
</div>
<div class="form-container">
  <div class="cards-container">
    <div class="row">
      <div class="col">
        <div class="textos">
          <img src="../../../../assets/images/ferias.png" class="img-mall" />
          <div class="nombre-local">Nombre</div>
          <!-- <mat-icon class="icon-description">lock</mat-icon> -->
          <img
            src="../../../../assets/images/alert.png"
            class="icon-description"
          />
          <div class="locales-disponibles">15 locales disponibles</div>
        </div>
      </div>
      <div class="col">
        <div class="textos">
          <img src="../../../../assets/images/ferias.png" class="img-mall" />
          <div class="nombre-local">Nombre</div>
          <!-- <mat-icon class="icon-description">lock</mat-icon> -->
          <img
            src="../../../../assets/images/alert.png"
            class="icon-description"
          />
          <div class="locales-disponibles">15 locales disponibles</div>
        </div>
      </div>
      <div class="col">
        <div class="textos">
          <img src="../../../../assets/images/ferias.png" class="img-mall" />
          <div class="nombre-local">Nombre</div>
          <!-- <mat-icon class="icon-description">lock</mat-icon> -->
          <img
            src="../../../../assets/images/alert.png"
            class="icon-description"
          />
          <div class="locales-disponibles">15 locales disponibles</div>
        </div>
      </div>
      <div class="col">
        <div class="textos">
          <img src="../../../../assets/images/ferias.png" class="img-mall" />
          <div class="nombre-local">Nombre</div>
          <!-- <mat-icon class="icon-description">lock</mat-icon> -->
          <img
            src="../../../../assets/images/alert.png"
            class="icon-description"
          />
          <div class="locales-disponibles">15 locales disponibles</div>
        </div>
      </div>
      <div class="col">
        <div class="textos">
          <img src="../../../../assets/images/ferias.png" class="img-mall" />
          <div class="nombre-local">Nombre</div>
          <!-- <mat-icon class="icon-description">lock</mat-icon> -->
          <img
            src="../../../../assets/images/alert.png"
            class="icon-description"
          />
          <div class="locales-disponibles">15 locales disponibles</div>
        </div>
      </div>
      <div class="col">
        <div class="textos">
          <img src="../../../../assets/images/ferias.png" class="img-mall" />
          <div class="nombre-local">Nombre</div>
          <!-- <mat-icon class="icon-description">lock</mat-icon> -->
          <img
            src="../../../../assets/images/alert.png"
            class="icon-description"
          />
          <div class="locales-disponibles">15 locales disponibles</div>
        </div>
      </div>
    </div>
  </div>
  <div class="botones">
    <button (click)="onCancel()" mat-button class="btn btn-cancelar">
      Cancelar
    </button>
    <button mat-button class="btn btn-continuar" (click)="openAlmacenModal()">
      Continuar
    </button>
  </div>
</div>

<div class="row cards"></div>
